/**
 * nav.js
 * -------
 * Toggles `.ko-nav--solid` once the user scrolls past a threshold
 * (default: 80% of viewport height, roughly "past the hero").
 * Progressive enhancement: if this fails to load, the nav simply
 * stays in its default (transparent) state — still fully usable,
 * just without the scroll transition.
 */
(function () {
  "use strict";

  var nav = document.querySelector(".ko-nav");
  if (!nav) return;

  var threshold = window.innerHeight * 0.8;
  var ticking = false;

  function updateNav() {
    if (window.scrollY > threshold) {
      nav.classList.add("ko-nav--solid");
    } else {
      nav.classList.remove("ko-nav--solid");
    }
    ticking = false;
  }

  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(updateNav);
      ticking = true;
    }
  });

  // Re-check on resize in case viewport height changes (mobile browser
  // chrome show/hide, orientation change)
  window.addEventListener("resize", function () {
    threshold = window.innerHeight * 0.8;
  });
})();
/* Global IntersectionObserver for Scroll Reveals */
(function () {
  "use strict";

  document.addEventListener('DOMContentLoaded', function () {
    const revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ko-reveal--visible');
          observer.unobserve(entry.target); // Stops watching once revealed to save browser memory
        }
      });
    }, { 
      threshold: 0.15 // Triggers when 15% of the element enters the screen
    });

    document.querySelectorAll('.ko-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  });
})();